import * as React from 'react';
import styled from 'styled-components';

interface IActiveFiltersNo {
    filtersNo: number;
}

const ActiveFiltersWrapper = styled.span`
    &::before {
        content: '(';
    }

    &::after {
        content: ')';
    }
`;

export const ActiveFiltersNo: React.StatelessComponent<IActiveFiltersNo> = (
    props: IActiveFiltersNo
) => {
    if (!props.filtersNo) {
        return null;
    }

    return (
        <ActiveFiltersWrapper className="elc-styled-filters-active-filters-no">
            {props.filtersNo}
        </ActiveFiltersWrapper>
    );
};
